import { toast } from 'react-toastify';
import { AI_SMS_TEMPLATE } from '../config/apiEndPoint';
import { GET, POST, PUT } from 'config/api.config';

export const fetchAISmsTemplateTableAndFilterSchema = async (data = {}) => {
    try {
        const url = data?._Id
            ? `${AI_SMS_TEMPLATE.GET_AI_SMS_TEMPLATE_SCHEMA}/${data?._Id}`
            : `${AI_SMS_TEMPLATE.GET_AI_SMS_TEMPLATE_SCHEMA}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const submitAISmsTemplateFilterData = async (data = {}) => {
    try {
        const response = await POST(AI_SMS_TEMPLATE.SUBMIT_FILTER_DATA, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const getAISmsTemplateDefinitions = async (data = {}) => {
    try {
        const response = await GET(AI_SMS_TEMPLATE.GET_DEFINITIONS, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const getAISmsTemplateById = async (id, data = {}) => {
    try {
        const response = await GET(AI_SMS_TEMPLATE.GET_AI_SMS_TEMPLATE_BY_ID(id), data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const addAISmsTemplate = async (data = {}) => {
    try {
        const response = await POST(AI_SMS_TEMPLATE.ADD_AI_SMS_TEMPLATE, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const updateAISmsTemplate = async (id, data = {}) => {
    try {
        const response = await PUT(AI_SMS_TEMPLATE.UPDATE_AI_SMS_TEMPLATE(id), data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
